import { defineChain } from 'viem';
import { chainConfig } from 'viem/zksync';

export const zkChainName = 'Xsolla ZK Sepolia Testnet';

export const xsollaZkChain = defineChain({
    ...chainConfig,
    id: 555272,
    name: zkChainName,
    nativeCurrency: {
        name: 'XSOLLAZK',
        symbol: 'ETH',
        decimals: 18
    },
    rpcUrls: {
        default: {
            http: ['https://zkrpc.xsollazk.com']
        }
    },
    blockExplorers: {
        default: {
            name: 'xla explorer',
            url: 'https://x.la/explorer'
        }
    },
    testnet: true
});
